import { useEffect, useState } from "react";
import { ClipLoader } from "react-spinners";
import { useAppDispatch, useAppSelector } from "../../../../app/hooks";
import { changeExtraConfig, getExtraConfig, selectExtraConfig, selectExtraDataLoading, updateExtraConfig } from "../../configurationSlice";



export const ExtraConfigView = () => {
  let dispatch = useAppDispatch();
  let loading = useAppSelector(selectExtraDataLoading)
  let extraConfig = useAppSelector(selectExtraConfig)

  let [urlError, setUrlError] = useState<string | null>(null);
  let [messageError, setMessageError] = useState<string | null>(null);
  let [updateEnabled, setUpdateEnabled] = useState(false);

  useEffect(() => {
    setUpdateEnabled(false);
    dispatch(getExtraConfig())
  }, [])

  useEffect(() => {
    if (extraConfig) {
      checkUrl(extraConfig.customTimeoutRedirection);
      checkMessage(extraConfig.customTimeoutMessage);
    }

  }, [extraConfig]);

  useEffect(() => {
    if (urlError || messageError) {

      setUpdateEnabled(false);
    }
    else {
      setUpdateEnabled(true);
    }
  }, [urlError, messageError]);

  const checkUrl = (url: string) => {
    const regex = /^(https):\/\/[^ "]+$/;
    if (!url) {
      setUrlError("Campo requerido");
    } else if (!regex.test(url)) {
      setUrlError("URL inválida");
    } else {
      setUrlError(null);
    }
  }

  const checkMessage = (message: string) => {
    if (!message) {
      setMessageError("Campo requerido");
    } else if (message.length > 100) {
      setMessageError("Máximo 100 caracteres");
    } else {
      setMessageError(null);
    }
  }

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "start",
        alignItems: "center",
        width: "100%",
      }}
    >
      <div
        style={{
          width: "100%",
          padding: "8px 0px 8px 0px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center",
          fontSize: "15px",
          backgroundColor: "rgba(0,0,0,0.4)",
          color: "rgba(255,255,255, 0.35)",
          borderRadius: "8px 8px 0px 0px",
        }}
      >
        Configuración de Timeout
      </div>
      <div
        style={{
          width: "100%",
          padding: "8px 0px 8px 16px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "start",
          fontSize: "13px",
          backgroundColor: "rgba(0,0,0,0.2)",
          minHeight: "280px",
          borderRadius: "0px 0px 8px 8px",
        }}
      >
        {(loading === "pending" || !extraConfig) ? (
          <ClipLoader color="#FFF" size="120px" />
        ) : (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              width: "100%",
              height: "100%",
              justifyContent: "space-between",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                width: "100%",
              }}
            >
              {" "}
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  marginTop: "12px",
                }}
              >
                <label
                  htmlFor="name"
                  style={{ width: "100%", marginRight: "10px", alignItems: "start" }}

                >
                  <p
                    style={{
                      fontSize: "11px",
                      color: "#FFF",
                      fontWeight: "400",
                      textAlign: "start",
                      margin: "0 0 2px 2px",
                    }}
                  >
                    Timeout activado
                  </p>
                  <input
                    id="timeoutActive"
                    name="timeoutActive"
                    onChange={(e) => {
                      dispatch(
                        changeExtraConfig({
                          ...extraConfig,
                          customTimeoutActive: e.target.checked,
                        })
                      );
                    }}
                    type="checkbox"
                    checked={extraConfig.customTimeoutActive}
                    style={{
                      border: "0.5px solid rgba(255,255,255,0.2)",
                      borderRadius: "6px",
                      background: "rgba(255,255,255,0.05)",
                      padding: "9px 0px 9px 0px",
                      minHeight: "24px",
                      fontSize: "12px",
                      fontWeight: "600",
                      textAlign: "start",
                      color: "#FFF",
                      marginTop: "10px",
                    }}
                  />
                </label>
                <label
                  htmlFor="timeoutMinutes"
                  style={{ width: "100%", marginRight: "10px" }}
                >
                  <p
                    style={{
                      fontSize: "11px",
                      color: "#FFF",
                      fontWeight: "400",
                      textAlign: "start",
                      margin: "0 0 2px 2px",
                    }}
                  >
                    Tiempo de timeout (minutos)
                  </p>
                  <input
                    id="timeoutMinutes"
                    name="timeoutMinutes"
                    type="text"
                    value={extraConfig.customTimeoutMinutes || 0}
                    onChange={(e) => {
                      if (Number.isInteger(Number(e.target.value))) {
                        dispatch(
                          changeExtraConfig({
                            ...extraConfig,
                            customTimeoutMinutes: Number(e.target.value),
                          })
                        );
                      }

                    }}
                    style={{
                      border: "0.5px solid rgba(255,255,255,0.2)",
                      borderRadius: "6px",
                      background: "rgba(255,255,255,0.05)",
                      padding: "9px 0px 9px 0px",
                      minHeight: "24px",
                      fontSize: "12px",
                      fontWeight: "600",
                      textAlign: "center",
                      color: "#FFF",
                      width: "100%",
                    }}
                  />
                </label>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  marginTop: "12px",
                }}
              >
                <label
                  htmlFor="rediretionUrl"
                  style={{ width: "100%", marginRight: "10px" }}
                >
                  <p
                    style={{
                      fontSize: "11px",
                      color: "#FFF",
                      fontWeight: "400",
                      textAlign: "start",
                      margin: "0 0 2px 2px",
                    }}
                  >
                    URL de redirección
                  </p>
                  <input
                    id="rediretionUrl"
                    name="rediretionUrl"
                    type="text"
                    value={extraConfig.customTimeoutRedirection || ""}
                    onChange={(e) => {
                      dispatch(
                        changeExtraConfig({
                          ...extraConfig,
                          customTimeoutRedirection: e.target.value,
                        })
                      );
                    }}
                    style={{
                      border: "0.5px solid rgba(255,255,255,0.2)",
                      borderRadius: "6px",
                      background: "rgba(255,255,255,0.05)",
                      padding: "9px 0px 9px 0px",
                      minHeight: "24px",
                      fontSize: "12px",
                      fontWeight: "600",
                      textAlign: "center",
                      color: "#FFF",
                      width: "100%",
                    }}
                  />
                  {urlError && (
                    <p
                      style={{
                        fontSize: "10px",
                        color: "rgba(255, 105, 105, 0.7)",
                        fontWeight: "400",
                        textAlign: "end",
                        margin: "2px 2px 0 0",
                      }}
                    >
                      {urlError}
                    </p>
                  )}
                </label>
                <label
                  htmlFor="phoneNumber"
                  style={{ width: "100%", marginRight: "10px" }}
                >
                  <p
                    style={{
                      fontSize: "11px",
                      color: "#FFF",
                      fontWeight: "400",
                      textAlign: "start",
                      margin: "0 0 2px 2px",
                    }}
                  >
                    Mensaje de timeout
                  </p>
                  <input
                    onChange={(e) => {
                      dispatch(
                        changeExtraConfig({
                          ...extraConfig,
                          customTimeoutMessage: e.target.value,
                        })
                      );
                    }}
                    id="phoneNumber"
                    name="phoneNumber"
                    type="text"
                    value={extraConfig.customTimeoutMessage || ""}
                    style={{
                      border: "0.5px solid rgba(255,255,255,0.2)",
                      borderRadius: "6px",
                      background: "rgba(255,255,255,0.05)",
                      padding: "9px 0px 9px 0px",
                      minHeight: "24px",
                      fontSize: "12px",
                      fontWeight: "600",
                      textAlign: "center",
                      color: "#FFF",
                      width: "100%",
                    }}
                  />
                  {messageError && (
                    <p
                      style={{
                        fontSize: "10px",
                        color: "rgba(255, 105, 105, 0.7)",
                        fontWeight: "400",
                        textAlign: "end",
                        margin: "2px 2px 0 0",
                      }}
                    >
                      {messageError}
                    </p>
                  )}
                </label>
              </div>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                marginTop: "18px",
                marginRight: "16px",
              }}
            >
              <button
                onClick={(e) => {
                  dispatch(
                    updateExtraConfig(extraConfig)
                  )
                }}

                disabled={!updateEnabled}
                style={{
                  width: "115px",
                  padding: "5px 0px 5px 0px",
                  textAlign: "center",
                  color: "#FFF",
                  background: updateEnabled ? "rgba(0,0,0,0.5)" : "rgba(0,0,0,0.1)",
                  borderRadius: "8px",
                  border: "none",
                  maxWidth: "120px",
                }}
              >
                Actualizar
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
